import React from 'react';

import Banner from '../../styleguide/banner/Banner';

const styles = require('./ClaudeMcpBanner.module.scss');

interface Props {
  dismissPath: string;
  setupPath: string;
}

function csrfToken(): string {
  const el = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null;
  return el ? el.content : '';
}

export default function ClaudeMcpBanner({ dismissPath, setupPath }: Props) {
  const dismiss = (): void => {
    // The mount node (see backoffice/_claude_mcp_banner.html.slim) reserves
    // min-height against hydration layout shift; collapse it now that the
    // banner is gone for the rest of the session.
    const mount = document.getElementById('bo-claude-mcp-banner-mount');
    if (mount) mount.style.minHeight = '0';

    // Fire-and-forget: the Banner already hid itself locally. If this fails,
    // the worst case is the banner reappearing on the next page load.
    void fetch(dismissPath, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-CSRF-Token': csrfToken() },
    }).catch(() => undefined);
  };

  return (
    <div className={styles['ui-claude-mcp-banner']}>
      <Banner
        className={styles['ui-claude-mcp-banner__banner']}
        variant="info"
        title="Connect Claude"
        description="Ask Claude anything across the backoffice, from talent and jobs to finances, and soon perform operations too. Every query runs with your own permissions."
        buttonLabel="Set up Claude"
        onButtonClick={() => window.location.assign(setupPath)}
        closable
        closeLabel="Dismiss until next sign-in"
        onClose={dismiss}
      />
    </div>
  );
}
